module.exports = __webpack_public_path__ + "img/zq2.1804f7d7.png";